import ResizableScene from "../core/ResizableScene";
export class StoryImageContainer extends Phaser.GameObjects.Container {
	scene: ResizableScene;
    storyImages: Phaser.GameObjects.Image[]=[];

    //There are 4-5 images for each story
    //separate atlases for each story
    story1Images = ["lmu-first-image-story-1", "lmu-second-image-story-1", "lmu-main-thrid-image-story-1", "lmu-fourth-image-story-1", "lmu-fifth-image-story-1"];
    story2Images = ["lmu-fifth-image-story-2", "lmu-second-image-story-2", "lmu-main-thrid-image-story-2", "lmu-fourth-image-story-2", "lmu-fifth-image-story-2"];
    story3Images = ["lmu-fifth-image-story-3", "lmu-second-image-story-3", "lmu-main-thrid-image-story-3", "lmu-fourth-image-story-3", "lmu-first-image-story-3"];

    storyBlurImages1 = ["lmu-fourth-image-story-1", "lmu-second-image-story-3", "lmu-main-thrid-image-story-3", "lmu-fourth-image-story-3", "lmu-main-thrid-image-story-1"];
    storyBlurImages2 = ["lmu-second-image-story-3", "lmu-second-image-story-1", "lmu-main-thrid-image-story-1", "lmu-fourth-image-story-1", "lmu-main-thrid-image-story-3"];
	    
    constructor(scene: ResizableScene) {
		super(scene, 0, 0);
		this.scene = scene;

        for(let i = 0; i < 5; i++){
            const img = scene.add.image(0, 0, "storyAtlas1", this.story1Images[i] + ".png");
            this.add(img);
            this.storyImages.push(img);
        }

        const filmTop = scene.add.image(0, 0, "film-strips", "lmu-static-film-strip-end-start-piece.png");
        const filmBottom = scene.add.image(0, 0, "film-strips", "lmu-static-film-strip-end-start-piece.png");
        const filmMid = scene.add.image(0, 0, "film-strips", "lmu-static-film-strip-middle-piece.png");
        this.add([filmBottom, filmTop, filmMid]);
        filmBottom.flipY = true;

        filmTop.y -= filmMid.displayHeight / 2 + filmTop.displayHeight / 2;
        filmBottom.y += filmMid.displayHeight / 2 + filmBottom.displayHeight / 2;

        this.setSize(filmMid.displayWidth, filmTop.displayHeight + filmMid.displayHeight + filmBottom.displayHeight);

        scene.alignIn.Center(this.storyImages[0], filmTop, -2, -214);
        scene.alignIn.Center(this.storyImages[1], filmTop, -2, 374);
        scene.alignIn.Center(this.storyImages[2], filmMid, -2, 0);
        scene.alignIn.Center(this.storyImages[3], filmBottom, -2, -379);
        scene.alignIn.Center(this.storyImages[4], filmBottom, -2, 208);
    }

    setStoryImages(atlas: string): void{
         let storyImageSet = this.story1Images;
        if(atlas == "storyAtlas3") storyImageSet = this.story3Images;
        else if(atlas == "storyAtlas2") storyImageSet = this.story2Images;

        for(let i = 0; i < this.storyImages.length; i++){
            this.storyImages[i].setTexture(atlas, storyImageSet[i] + ".png");
        }
    }

    setStoryImageTint(setTint: boolean): void {
        for(let i = 0; i < this.storyImages.length; i++){
            this.storyImages[i].setTint((setTint) ? 0xdddddd : 0xffffff);
        }
    }

}